<rt-work-model-section
  [workModelControl]="workModelControl"
  [readOnly]="!isFormEditable"
  [viewContext]="WorkModelSectionViewContext.Requisition"
/>
